module.exports = __webpack_public_path__ + "img/test2.bab5edad.jpg";